import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"text-center",staticStyle:{"height":"calc(100vh - 58px)"},attrs:{"fill-height":""}},[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,[_c('h1',{staticClass:"display-2 primary--text"},[_vm._v("401, Unauthorize")]),_c('p',[_vm._v("You dont have access to this page")]),_c(VBtn,{attrs:{"to":"/","color":"primary","outlined":""}},[_vm._v("Get me out of here!")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }